import { Link, useLocation, useNavigate, Outlet } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Wordmark } from "@/components/site/Wordmark";
import { LayoutDashboard, Inbox, FileText, Users, Settings, LogOut, ExternalLink, Search, MessageSquare } from "lucide-react";

const NAV = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/leads", label: "Leads", icon: Inbox },
  { to: "/admin/conversations", label: "Conversations", icon: MessageSquare },
  { to: "/admin/insights", label: "Insights", icon: FileText },
  { to: "/admin/leadership", label: "Leadership", icon: Users },
  { to: "/admin/seo", label: "SEO", icon: Search },
  { to: "/admin/settings", label: "Settings", icon: Settings },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = (to, end) => (end ? location.pathname === to : location.pathname.startsWith(to));

  const onLogout = async () => { await logout(); navigate("/admin/login", { replace: true }); };

  return (
    <div className="min-h-screen bg-off-white flex">
      <aside className="w-64 bg-deep-navy text-white flex flex-col fixed h-screen">
        <div className="p-6 border-b border-white/10"><Wordmark light /></div>
        <nav className="flex-1 p-4 space-y-1">
          {NAV.map((item) => {
            const Icon = item.icon;
            const active = isActive(item.to, item.end);
            return (
              <Link key={item.to} to={item.to} data-testid={`admin-nav-${item.label.toLowerCase()}`}
                    className={`flex items-center gap-3 px-4 py-3 text-sm transition-colors ${active ? "bg-restrained-blue text-white" : "text-white/70 hover:bg-white/5 hover:text-white"}`}>
                <Icon size={17} /> {item.label}
              </Link>
            );
          })}
        </nav>
        <div className="p-4 border-t border-white/10 space-y-1">
          <a href="/" target="_blank" rel="noreferrer" className="flex items-center gap-3 px-4 py-3 text-sm text-white/70 hover:text-white">
            <ExternalLink size={17} /> View site
          </a>
          <button onClick={onLogout} data-testid="admin-logout" className="w-full flex items-center gap-3 px-4 py-3 text-sm text-white/70 hover:text-white">
            <LogOut size={17} /> Sign out
          </button>
        </div>
      </aside>
      <div className="flex-1 ml-64">
        <header className="bg-white border-b border-[#E5E5E5] px-8 py-4 flex justify-between items-center sticky top-0 z-10">
          <p className="text-sm text-charcoal/60">Signed in as <span className="text-charcoal font-medium">{user?.email}</span></p>
        </header>
        <div className="p-8"><Outlet /></div>
      </div>
    </div>
  );
}
